<script>
import { defineComponent } from 'vue'

import ClientsMap from './dashlets/clients-map.vue'
import ClientsLocationPlan from './dashlets/clients-location-plan.vue'
import ClientsList from './dashlets/clients-list.vue'
import Journal from './dashlets/journal.vue'
import Mediapool from './dashlets/mediapool.vue'
import DashletPublish from './dashlets/publish/dashlet-publish.vue'
import Storage from './dashlets/storage.vue'
import DashletsSettingsModal from './settings/dashlets-settings-modal.vue'
import MyuserDialog from "../administration/myuser/components/myuser-dialog.vue";

export default defineComponent({
    name: 'screen-dashboard',
    components: {
        DashletsSettingsModal,
        ClientsMap,
        ClientsLocationPlan,
        ClientsList,
        Journal,
        Mediapool,
        DashletPublish,
        Storage,
        MyuserDialog
    },
    props: {
        /** @type {'1' | undefined} */
        privilegeManage: String,
        clients: {
            type: Array,
            default: () => []
        },
        mapData: {
            type: [Object, Array],
            default: () => {
            }
        },
        locations: {
            type: Array,
            default: () => []
        },
        dashletColumn1: {
            type: Array,
            default: () => []
        },
        dashletColumn2: {
            type: Array,
            default: () => []
        },
        settings: Object
    },
    computed: {
        dashletColumns() {
            const value = []
            if (this.dashletColumn1.length > 0) value.push(this.dashletColumn1)
            if (this.dashletColumn2.length > 0) value.push(this.dashletColumn2)
            return value
        },
        singleColumn() {
            return this.dashletColumn1.length === 0 || this.dashletColumn2.length === 0
        },
        clientCount() {
            return Object.values(this.clients).reduce((accumulator, currentValue) => {
                return accumulator + currentValue?.clients.length ?? 0
            }, 0)
        },
        t_clientCount() {
            return `${this.clientCount} ${Lang.langChoice('Client|Clients', this.clientCount)}`
        }
    }
})
</script>

<template>
    <div :class="{
            'single-column': singleColumn,
            'no-dashlets': dashletColumns.length === 0
        }"
         class="dashboard">
        <div v-for="dashletColumn in dashletColumns"
             class="dashboard-column">
            <template v-for="dashlet in dashletColumn">
                <h1 class="hidden">{{ 'Dashboard' }}</h1>
                <clients-map
                    v-if="dashlet === 'clients-map'"
                    :defaultCenter="settings['clients-map']['center']"
                    :googleMapsApiKey="settings['clients-map']['api-key']"
                    :locations="locations"
                    :mapData="mapData"
                    :privilegeManage="privilegeManage"
                    :tClientCount="t_clientCount" />
                <clients-location-plan
                    v-else-if="dashlet === 'clients-location-plan'"
                    :locations="locations"
                    :privilegeManage="privilegeManage" />
                <clients-list
                    v-else-if="dashlet === 'clients-list'"
                    :clients="clients"
                    :privilegeManage="privilegeManage"
                    :tClientCount="t_clientCount" />
                <journal
                    v-else-if="dashlet === 'journal'"
                    :showCount="+settings.journal['show-count']" />
                <dashlet-publish
                    v-else-if="dashlet === 'publish'"
                    :screens-data="settings.publish['screens-data']"
                    :showCount="+settings.publish['show-count']" />
                <mediapool
                    v-else-if="dashlet === 'mediapool'"
                    :showCount="+settings.mediapool['show-count']" />
                <storage
                    v-else-if="dashlet === 'storage'" />
            </template>
        </div>

        <dashlets-settings-modal />
    </div>
</template>


<style>
body {
    /* Disable body min-width on this page, since it's responsive */
    min-width: unset !important;
}
</style>
